var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found-ctr flex-all-centered-row"},[_c('div',{staticClass:"flex-all-centered-col"},[_c('div',{staticClass:"dashboard-button",on:{"click":_vm.goToDashboard}},[_vm._v("\n                Back to Dashboard\n            ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }